/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {PoliticalEntityListPageComponent} from './political-entity-list-page.component';

@Component({
  standalone: true,
  imports: [PoliticalEntityListPageComponent],
  selector: 'adn-political-entity-route-page',
  template: `
    <adn-political-entity-list-page
      [readOnly]="readOnly">
    </adn-political-entity-list-page>
  `
})
export class PoliticalEntityRoutePageComponent {
  @Input() readOnly = false;
}
